/* Error helpers for API layer */

export type ApiErrorPayload = {
  message?: string;
  code?: string | number;
  details?: unknown;
};

export class ApiError extends Error {
  status: number;
  payload?: ApiErrorPayload | unknown;

  constructor(message: string, status: number, payload?: ApiErrorPayload | unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

export function toApiError(e: unknown): ApiError {
  if (e instanceof ApiError) return e;
  // Fetch http() throws an Error with status and data
  if (e && typeof e === 'object' && 'status' in e) {
    const err = e as any;
    const status = typeof err.status === 'number' ? err.status : 0;
    const raw = err?.data;
    let message: string;
    if (typeof raw === 'string' && raw.length > 0) {
      message = raw;
    } else if (raw && typeof raw === 'object') {
      const validationErrors = raw?.errors || raw?.Errors;
      const validationMessage =
        validationErrors && typeof validationErrors === 'object'
          ? Object.values(validationErrors)
              .flat()
              .join(' | ')
          : undefined;
      message =
        validationMessage ||
        raw?.message ||
        raw?.Message ||
        raw?.error ||
        raw?.title ||
        `HTTP ${status}`;
    } else {
      message = `HTTP ${status}`;
    }
    return new ApiError(message, status, raw);
  }
  return new ApiError('Unexpected error', 0, undefined);
}
